import React from 'react';
import styles from './SocialLinks.module.scss';
import { Image, T } from '@colonist/ui';
import { passThroughTranslation } from '@colonist/i18n';
import SocialDiscord from '@static/images/social_icon_discord.svg';
import SocialYoutube from '@static/images/social_icon_youtube.svg';
import SocialReddit from '@static/images/social_icon_reddit.svg';
import SocialInstagram from '@static/images/social_icon_instagram.svg';
import SocialFacebook from '@static/images/social_icon_facebook.svg';
import SocialX from '@static/images/social_icon_x.svg';
import { DISCORD_CHANNEL } from '@colonist/consts';
export const SocialLinks = ({ className })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement("h3", {
        className: styles.headerText
    }, /*#__PURE__*/ React.createElement(T, {
        id: "strings:morePage.followUs"
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.row
    }, socialLinks.map((link)=>/*#__PURE__*/ React.createElement("a", {
            key: link.ariaLabel,
            className: styles.iconLink,
            href: link.url,
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": link.ariaLabel
        }, /*#__PURE__*/ React.createElement(Image, {
            className: styles.icon,
            image: link.image
        })))));
};
const socialLinks = [
    {
        image: {
            src: SocialDiscord,
            alt: passThroughTranslation('Discord')
        },
        url: DISCORD_CHANNEL,
        ariaLabel: 'Discord'
    },
    {
        image: {
            src: SocialYoutube,
            alt: passThroughTranslation('YouTube')
        },
        url: 'https://www.youtube.com/channel/UCkmPiTR8n0zqT6tIuUK0klA',
        ariaLabel: 'YouTube'
    },
    {
        image: {
            src: SocialReddit,
            alt: passThroughTranslation('Reddit')
        },
        url: 'https://www.reddit.com/r/Colonist/',
        ariaLabel: 'Reddit'
    },
    {
        image: {
            src: SocialInstagram,
            alt: passThroughTranslation('Instagram')
        },
        url: 'https://www.instagram.com/colonist_io/',
        ariaLabel: 'Instagram'
    },
    {
        image: {
            src: SocialFacebook,
            alt: passThroughTranslation('Facebook')
        },
        url: 'https://www.facebook.com/colonistio/',
        ariaLabel: 'Facebook'
    },
    {
        image: {
            src: SocialX,
            alt: passThroughTranslation('X')
        },
        url: 'https://x.com/colonistio',
        ariaLabel: 'X'
    }
];
